import styled from 'styled-components';

export const AudienceProfileStyled = styled.div`
  .audienceProfile {
    &__stepTwo {
      display: flex;
      flex-direction: column;
      row-gap: 24px;
      
      &Checkbox {
        background-color: ${props => props.theme.uiColors.contextSystemViewItemBackground};
        border-radius: 6px;
        font-family: ${props => props.theme.fontRegular};
        padding: 10px;
      }
    }

    &__modal--profileTypeStep .stepsWizardHeader {
      &__mainTitleSeparator,
      &__mainTitleSecondary,
      &__breadcrumb {
        display: none;
      }

      &__mainTitlePrimary {
        color: var(--color-sonata-primary-700);
        font: var(--font-body-600-bold);
      }
    }
  }
`;
